
<!-- <bb-canvas
(initialized)="canvasInitialized = true"
[zoomToFit]="true"
class="project-stats-canvas">
	<project-flowchart *ngIf="project" [project]="project"></project-flowchart>

</bb-canvas> -->

<bb-date-presets *ngIf="statsMode"
	(onChanged)="datesChanged($event)"
	[preset]="'last-30-days'"
	[icon]="'line-chart'"
	[minDate]="minDate"
	[minDateWarning]="'HELP.PROJECT_STATS_DATE_CORRECTED' | translate: {date: (minDate | date)}"
>
	<a footer class="button download feedback" (click)="downloadFormData()">
			<i class="fa fa-comments-o"></i>
		{{ 'DOWNLOAD_FORM_DATA' | translate }}
	</a>

	<a footer class="button download statistics" href="{{ projectDownloadUrl }}/sheet?{{ projectStatsDates }}">
		<i class="fa fa-line-chart"></i>
		{{ 'DOWNLOAD_STATISTICS' | translate }}
	</a>
</bb-date-presets>

<div [hasPermission]="'root'" (click)="rebuildFlowchart()" class="root button">{{ 'REBUILD_FLOWCHART' | translate }}</div>

<flowchart-editor *ngIf="project" [flowchart]="project.flowchart" [haveProjectStepsStats]="!!project?.chapters" [statsMode]="statsMode" [disableDragging]="false" [checklistItems]="checklistItems"></flowchart-editor>
